import { isPlainArrayField } from '../../../../datatype/Datatype';
import { createConditionOperator } from '../../IConditionOperator';

export const ConditionOperatorContainsOne = createConditionOperator({
  code: 'containsOne',
  label: 'contiene almeno uno',
  description: 'Contiene almeno uno degli elementi',
  args: [
    {
      type: 'referenceValue',
      isArray: true,
    },
  ],
  allowsField: field => isPlainArrayField(field),
  compare(value: any, [items]: readonly [any[]]) {
    if (!Array.isArray(value) || !items) {
      return false;
    }

    return value.some(item => items.includes(item));
  },
});
